import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import LoadingAnimation from "../components/Loading";


// AMPLIFY
import { generateClient } from 'aws-amplify/api';
import { updateUserStatus } from '../graphql/mutations';
import { listUserStatuses,listTransactions } from '../graphql/queries';
import * as subscriptions from '../graphql/subscriptions';

// COOKIES
import Cookies from 'js-cookie';


// CONTEXT
import { useAuth } from '../contexts/AuthContext';



const Navbar2 = () => {

  const { user,logout } = useAuth();
  
  const lawyerId = user.user_id;
  const lawyerImage = user.user_profile_photo;

  

  const [transactions, setTransactions]         = useState([]);
  const [loading, setLoading]                   = useState(true);
  const [transactionCount, setTransactionCount] = useState(0);


const client = generateClient();




//    // Fetch the initial transactions
//    useEffect(() => {
//     const fetchTransactions = async (lawyerId) => {

//       const variables = {
//         filter: {
//           lawyer_id: { eq: lawyerId }  // Dynamic filter for lawyer_id
//         }
//       };

//         try {
//             const result = await client.graphql({
//                 query    : listTransactions,
//                 variables: variables,
//             });

            
//             const fetchedTransactions = result.data.listTransactions.items;
//             const count               = fetchedTransactions.length;

//             setTransactionCount(count)

 
            
            
            
//             // Sort the transactions based on the 'date_created' field in descending order (newest first)
//             const sortedTransactions = fetchedTransactions.sort((a, b) => 
//             new Date(b.date_created) - new Date(a.date_created)
//             );

//             // Set the state with the sorted transactions
//             setTransactions(sortedTransactions); 
            

//         } catch (error) {
//             console.error('Error fetching transactions:', error);
//         } finally {
//             setLoading(false);
//         }
//     };

    
//     fetchTransactions(lawyerId);

//     // Subscribe to real-time updates when a new transaction is created
//     const createSub = client
//         .graphql({ query: subscriptions.onCreateTransaction })
//         .subscribe({
//             next: ({ data }) => {
//                 const newTransaction = data.onCreateTransaction;
//                 setTransactions((prevTransactions) => [newTransaction, ...prevTransactions]);
//                 console.log("1");
//             },
//             error: (error) => {
//                 console.warn('Subscription error:', error);
//             },
//         });

//     // Subscribe to real-time updates when a transaction is updated
//     const updateSub = client
//         .graphql({ query: subscriptions.onUpdateTransaction })
//         .subscribe({
//             next: ({ data }) => {
//                 const updatedTransaction = data.onUpdateTransaction;

//                 if(updatedTransaction.lawyer_id===lawyerId){
//                   setTransactionCount(prevCount => prevCount + 1);
//                 }

                

//                 setTransactions((prevTransactions) => {
//                     return prevTransactions.map((transaction) =>
//                         transaction.id === updatedTransaction.id ? updatedTransaction : transaction
//                     );
//                 });

                

                

//                 console.log(updatedTransaction);
//             },
//             error: (error) => {
//                 console.warn('Subscription error:', error);
//             },
//         });



//     // Subscribe to real-time updates when a transaction is deleted
//     const deleteSub = client
//         .graphql({ query: subscriptions.onDeleteTransaction })
//         .subscribe({
//             next: ({ data }) => {
//                 const deletedTransaction = data.onDeleteTransaction;
//                 setTransactions((prevTransactions) => {
//                     return prevTransactions.filter((transaction) => transaction.id !== deletedTransaction.id);
//                 });
//                 console.log("3");
//             },
//             error: (error) => {
//                 console.warn('Subscription error:', error);
//             },
//         });

//     // Cleanup subscriptions on component unmount
//     return () => {
//         createSub.unsubscribe();
//         updateSub.unsubscribe();
//         deleteSub.unsubscribe();
//     };
// }, []);


 




 



   
  const updateUserStatusHandler = async (user_profile_id, user_status) => {
    const input = {
      user_profile_id: user_profile_id,
      user_status: user_status,
      updatedAt: new Date().toISOString(),  // Set the current time for updatedAt
    };
  
    const variables = { user_profile_id };  // Variables to check if the user already exists
  
    try {
      // Step 1: Check if the user already exists
      const checkResponse = await client.graphql({
        query: listUserStatuses,
        variables: variables,
      });
  


    if (checkResponse.data.listUserStatuses.items.length > 0) {
      console.log('User status already exists, updating...');

      // Step 2: If the user exists, get the ID and update the user status
      const existingStatus = checkResponse.data.listUserStatuses.items[0];  // Take the first item (you may need to adjust if there are multiple)

      // Define the update mutation variables
      const updateVariables = {
        input: {
          id: existingStatus.id,  // The ID of the existing user status
          user_status: user_status,  // New status to update
        },
        condition: {
          user_profile_id: { eq: user_profile_id },  // The condition to ensure we update the correct user
        },
      };

      // Step 3: Call the update mutation
      const updateResponse = await client.graphql({
        query: updateUserStatus,  // The mutation to update the user status
        variables: updateVariables,
      });

      console.log('User status updated:', updateResponse.data.updateUserStatus);

     // window.location.reload();

      return;
    }


    

  
    } catch (error) {
      console.error('Error updating user status:', error);
    }
  };

  const [fullname, setFullname] = useState("");
  const [username, setUsername] = useState("");
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  useEffect(() => {
    const first_name = user.first_name;
    const last_name = user.last_name;

    setUsername(user.email);
    setFullname(`${first_name?.toUpperCase() || ''} ${last_name?.toUpperCase() || ''}`);
  }, []);


  const clearAllCookies = () => {
    // Get all cookies
    const allCookies = Cookies.get();
  
    // Loop through all cookies and remove them
    for (const cookieName in allCookies) {
      if (allCookies.hasOwnProperty(cookieName)) {
        Cookies.remove(cookieName); // Remove each cookie
      }
    }
  };

 

  const handleLogout = async () => {
    setIsLoggingOut(true);

    const accessToken = Cookies.get('access_token');
    const refreshToken = Cookies.get('refresh_token');


    try {



      // await axios.post(
      //   `${process.env.REACT_APP_API_URL}/logout/`,
      //   { refresh_token: refreshToken },
      //   {
      //     headers: {
      //       Authorization: `Bearer ${accessToken}`,
      //     },
      //   }
      // );
      

      const user_id = user.user_id;
      updateUserStatusHandler(user_id,0);

      // Clear tokens from local storage
      //clearAllCookies();
 
 
      //window.location.reload();

    logout();



    } catch (error) {
      console.error('Logout failed:', error);
    }
  };



  return (
    <nav
            class="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
            id="layout-navbar">
            <div class="layout-menu-toggle navbar-nav align-items-xl-center me-4 me-xl-0 d-xl-none">
              <a class="nav-item nav-link px-0 me-xl-6" href="javascript:void(0)">
                <i class="bx bx-menu bx-md"></i>
              </a>
            </div>

            <div class="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
              
              <div class="navbar-nav align-items-center">
                <div class="nav-item navbar-search-wrapper mb-0">
                  <a class="nav-item nav-link search-toggler px-0" href="javascript:void(0);">
                    <i class="bx bx-search bx-md"></i>
                    <span class="d-none d-md-inline-block text-muted fw-normal ms-4">Search (Ctrl+/)</span>
                  </a>
                </div>
              </div>
              

              <ul class="navbar-nav flex-row align-items-center ms-auto">
                
               
               
              
                
                <li class="nav-item navbar-dropdown dropdown-user dropdown">

                    


                  <a
                    class="nav-link dropdown-toggle hide-arrow p-0"
                    href="javascript:void(0);"
                    data-bs-toggle="dropdown">
                    <div class="avatar avatar-online">
                      

                      {
                        lawyerImage &&
                        <img
                            src={lawyerImage}
                            alt="user"
                            className="w-px-40 h-auto rounded-circle"
                        />
                        }
                    </div>
                  </a>


                      <ul className="dropdown-menu dropdown-menu-end">
                    {/*?php foreach ($notifications as $notification): ?*/}
                    <li>{/*?= $notification['subj_name'] ?*/}</li>
                    {/*?php endforeach; ?*/}
                    <li>
                      <Link className="dropdown-item" >
                        <div className="d-flex">
                          <div className="flex-shrink-0 me-3">
                            <div className="avatar avatar-online">
                              {
                                lawyerImage &&
                                <img
                                  src={lawyerImage}
                                  alt="user"
                                  className="w-px-40 h-auto rounded-circle"
                                />
                                }
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <span className="fw-medium d-block">
                              {username}
                            </span>
                            {/* <small className="text-muted">Encoder</small> */}
                          </div>
                        </div>
                      </Link>
                    </li>


                    <li>
                      <div className="dropdown-divider" />
                    </li>

                    <li>
                      <button onClick={handleLogout} className="dropdown-item" >
                        <i className="bx bx-power-off bx-sm me-3"></i><span>Log Out</span>
                      </button>
                    </li>


                  </ul>


                </li>
                
              </ul>
            </div>

            
            <div class="navbar-search-wrapper search-input-wrapper d-none">
              <input
                type="text"
                class="form-control search-input container-xxl border-0"
                placeholder="Search..."
                aria-label="Search..." />
              <i class="bx bx-x bx-md search-toggler cursor-pointer"></i>
            </div>
          </nav>
  );
}

export default Navbar2;